import { HttpClient } from '@adapters/HttpClient';

export interface Country {
  id: number;
  name: string;
  iso2: string;
  iso3: string;
  phoneCode: string;
  createdAt: string;
  updatedAt: string;
}

export interface CountryOption {
  id: string;
  name: string;
  iso2: string;
}

export class CountriesApiAdapter {
  constructor(private httpClient: HttpClient) {}

  async getAll(): Promise<CountryOption[]> {
    const raw = await this.httpClient.get<any>('/countries');
    
    const list = Array.isArray(raw) ? raw : Array.isArray(raw?.data) ? raw.data : [];
    
    const mapped = list.map((country: Country) => ({
      id: String(country.id),
      name: country.name,
      iso2: country.iso2,
    }));
    
    return mapped;
  }
}
